import Vue from 'vue';
import Vue2Filters from 'vue2-filters';
import BootstrapVue from 'bootstrap-vue';
import Autocomplete from 'v-autocomplete';
import CxltToastr from 'cxlt-vue2-toastr';
import Vuelidate from 'vuelidate';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';
import Icon from 'vue-awesome/components/Icon';
import NProgress from 'vue-nprogress';
import VueCookie from 'vue-cookie';
import { sync as routerSync } from 'vuex-router-sync';
import App from '@/components/app/App.vue';
import { GotuNavButton, i18n } from '~';
import router from '@/state/router';
import store from '@/store';
import VueI18Next from '@panter/vue-i18next';
import PortalVue from 'portal-vue';

routerSync(store, router, { moduleName: 'router' });

const localeRequireContext = require.context('@/locales', true, /\.ya?ml$/);
i18n.init(localeRequireContext);

if (module.hot) {
  module.hot.accept(localeRequireContext, () => {
    i18n.reload(require.context('@/locales', false, /\.ya?ml$/));
  });
}

const nprogress = new NProgress({ parent: '.nprogress-bar' });
const progressOptions = {
  latencyThreshold: 100, // Number of ms before progressbar starts showing, default: 100,
  router: false, // Show progressbar when navigating routes, default: true
  http: false, // Show progressbar when doing Vue.http, default: true
  trickleSpeed: 100,
  easing: 'ease',
  speed: 100,
  showSpinner: false,
};

Vue.config.productionTip = false;
Vue.config.devtools = process.env.WITH_DEVTOOLS || process.env.NODE_ENV !== 'production';

if (process.env.SENTRY_URL) {
  const ravenConfig = {};
  if (process.env.GIT_SHA1) {
    ravenConfig.release = process.env.GIT_SHA1;
  }

  Raven
    .config(process.env.SENTRY_URL, ravenConfig)
    .addPlugin(RavenVue, Vue)
    .install();
}

// Plugins
Vue.use(VueI18Next);
Vue.use(BootstrapVue);
Vue.use(Autocomplete);
Vue.use(Vue2Filters);
Vue.use(Vuelidate);
Vue.use(VueAwesomeSwiper);
Vue.use(VueCookie);
Vue.use(PortalVue);
Vue.use(NProgress, progressOptions);
Vue.use(CxltToastr, {
  position: 'top right',
  closeButton: true,
  timeOut: 5000,
});

// Global components
Vue.component('icon', Icon);
Vue.component('gotu-nav-button', GotuNavButton);

// eslint-disable-next-line no-new
new Vue({
  el: '#app',
  i18n: new VueI18Next(i18n.default),
  store,
  router,
  nprogress,
  template: '<App/>',
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js